import { handlePrevious } from "../utils/navigationUtils";
import { assetsPath } from "../utils/assetsPath";

const FormNavigationButtons = ({
  prevStep,
  nextStep = true,
  isValid,
  onClick,
  type = "submit",
}) => {
  return (
    <>
      <div className="multiBtn">
        {/* Show Back button if there's a previous step */}
        {prevStep && (
          <button
            type="button"
            className="prevBtn"
            onClick={() => handlePrevious(prevStep)}
          >
            <img className="PrevImg" src={assetsPath.previous} alt="Previous" />
          </button>
        )}

        {/* Show Next button if there's a next step */}
        {nextStep && (
          <button
            type={type}
            onClick={isValid ? onClick : null}
            className={`nextBtn ${
              !isValid ? "buttonGreyOut" : "getStartedButton"
            }`}
          >
            Next{" "}
            <img
              className="forwardImg"
              src={assetsPath.forward}
              alt="forward"
            />
          </button>
        )}
      </div>
    </>
  );
};

export default FormNavigationButtons;
